import { Component, Input, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { ContextMenuOption } from '../models/context-menu-option';

@Component({
    selector: 'lib-context-menu',
    templateUrl: './context-menu.component.html',
    styleUrls: ['./context-menu.component.scss'],
    standalone: false
})
export class ContextMenuComponent implements OnInit {
  @Input() contextMenuOptions!: ContextMenuOption[];

  constructor(private popoverCtrl: PopoverController) {}

  ngOnInit() {}

  selectOption(value: string) {
    this.popoverCtrl.dismiss(value, 'selected');
  }
}
